export const DEFAULT_ARTIFACT_HTML = `<form data-artifact-event="submitted" style="margin: 0;">
  <section style="background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%); border: 1px solid #dde5f3; border-radius: 20px; box-shadow: 0 16px 40px rgba(31, 45, 78, 0.08); color: #172033; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; padding: 24px;">
    <header style="border-bottom: 1px solid #e8edf6; margin-bottom: 20px; padding-bottom: 18px;">
      <p style="color: #4764ff; font-size: 12px; font-weight: 700; letter-spacing: 0.08em; margin: 0 0 8px; text-transform: uppercase;">Action request</p>
      <h2 style="color: #172033; font-size: 24px; letter-spacing: -0.03em; line-height: 1.2; margin: 0;">Review and submit your response</h2>
      <p style="color: #65728a; font-size: 14px; line-height: 1.55; margin: 10px 0 0;">Use this form to capture a structured human decision before the workflow continues.</p>
    </header>

    <div style="display: grid; gap: 16px; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); margin-bottom: 16px;">
      <label style="color: #344054; display: block; font-size: 13px; font-weight: 650; grid-column: 1 / -1; line-height: 1.4;">
        Decision
        <select name="decision" required style="border: 1px solid #cfd6e4; border-radius: 10px; box-sizing: border-box; display: block; font: inherit; margin-top: 6px; max-width: 100%; padding: 10px 12px; width: 100%;">
          <option value="">Select a decision</option>
          <option value="approved">Approved</option>
          <option value="needs_changes">Needs changes</option>
          <option value="blocked">Blocked</option>
        </select>
      </label>

      <label style="color: #344054; display: block; font-size: 13px; font-weight: 650; line-height: 1.4;">
        Owner
        <input name="owner" type="text" placeholder="Who is responsible?" required style="border: 1px solid #cfd6e4; border-radius: 10px; box-sizing: border-box; display: block; font: inherit; margin-top: 6px; max-width: 100%; padding: 10px 12px; width: 100%;" />
      </label>

      <label style="color: #344054; display: block; font-size: 13px; font-weight: 650; line-height: 1.4;">
        Due date
        <input name="due_date" type="date" style="border: 1px solid #cfd6e4; border-radius: 10px; box-sizing: border-box; display: block; font: inherit; margin-top: 6px; max-width: 100%; padding: 10px 12px; width: 100%;" />
      </label>
    </div>

    <label style="color: #344054; display: block; font-size: 13px; font-weight: 650; line-height: 1.4;">
      Notes
      <textarea
        name="notes"
        rows="5"
        maxlength="4000"
        placeholder="Add context, constraints, or the next action needed."
        required
        style="border: 1px solid #cfd6e4; border-radius: 10px; box-sizing: border-box; display: block; font: inherit; margin-top: 6px; max-width: 100%; padding: 10px 12px; width: 100%;"
      ></textarea>
    </label>

    <footer style="align-items: center; display: flex; flex-wrap: wrap; gap: 16px; justify-content: space-between; margin-top: 18px;">
      <small style="color: #65728a; font-size: 12px; line-height: 1.4;">Your response is recorded against this artifact instance.</small>
      <button type="submit" style="background: #172033; border: 0; border-radius: 10px; color: #ffffff; cursor: pointer; font: inherit; font-weight: 650; margin-top: 12px; padding: 11px 16px;">Submit response</button>
    </footer>
  </section>
</form>`;

export const DEFAULT_ARTIFACT_TYPESCRIPT = `artifact.render((root, runtime) => {
  const state = {
    likelihood: 3,
    impact: 3,
    owner: '',
    escalationReason: '',
    mitigationActions: []
  };

  const likelihoodRows = [
    { value: 5, label: 'Almost certain' },
    { value: 4, label: 'Likely' },
    { value: 3, label: 'Possible' },
    { value: 2, label: 'Unlikely' },
    { value: 1, label: 'Rare' }
  ];
  const impactColumns = [
    { value: 1, label: 'Negligible' },
    { value: 2, label: 'Minor' },
    { value: 3, label: 'Moderate' },
    { value: 4, label: 'Major' },
    { value: 5, label: 'Severe' }
  ];

  const styles = {
    page: 'background: #f8fafc; color: #020817; font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; padding: 24px;',
    card: 'background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08); margin: 0 auto; max-width: 860px; overflow: hidden;',
    header: 'border-bottom: 1px solid #e2e8f0; padding: 24px 24px 18px;',
    badge: 'background: #f1f5f9; border: 1px solid #e2e8f0; border-radius: 999px; color: #475569; display: inline-flex; font-size: 12px; font-weight: 600; letter-spacing: 0.01em; margin-bottom: 12px; padding: 4px 10px;',
    title: 'font-size: 22px; font-weight: 650; letter-spacing: -0.03em; line-height: 1.2; margin: 0;',
    description: 'color: #64748b; font-size: 14px; line-height: 1.55; margin: 8px 0 0;',
    body: 'display: grid; gap: 16px; padding: 24px;',
    label: 'color: #0f172a; display: grid; font-size: 13px; font-weight: 600; gap: 8px;',
    matrix: 'display: grid; gap: 8px; grid-template-columns: 128px repeat(5, minmax(0, 1fr));',
    matrixHeader: 'align-items: center; color: #64748b; display: flex; font-size: 12px; font-weight: 600; justify-content: center; min-height: 36px; text-align: center;',
    rowHeader: 'align-items: center; color: #475569; display: flex; font-size: 12px; font-weight: 650;',
    cell: 'border: 1px solid transparent; border-radius: 12px; color: #0f172a; cursor: pointer; display: grid; gap: 4px; min-height: 72px; padding: 10px; text-align: left;',
    cellSelected: 'outline: 3px solid #0f172a; outline-offset: 2px;',
    cellTitle: 'font-size: 13px; font-weight: 700;',
    cellDetail: 'color: inherit; font-size: 11px; line-height: 1.35; opacity: 0.76;',
    control: 'background: #ffffff; border: 1px solid #cbd5e1; border-radius: 10px; color: #0f172a; font: inherit; outline: none; padding: 10px 12px; width: 100%;',
    textarea: 'background: #ffffff; border: 1px solid #cbd5e1; border-radius: 10px; color: #0f172a; font: inherit; min-height: 112px; outline: none; padding: 10px 12px; resize: vertical; width: 100%;',
    actions: 'display: grid; gap: 10px;',
    actionRow: 'align-items: center; display: grid; gap: 8px; grid-template-columns: 1fr auto;',
    secondaryButton: 'background: #ffffff; border: 1px solid #cbd5e1; border-radius: 10px; color: #0f172a; cursor: pointer; font: inherit; font-size: 13px; font-weight: 600; padding: 8px 12px;',
    removeButton: 'background: #ffffff; border: 1px solid #fecaca; border-radius: 10px; color: #b91c1c; cursor: pointer; font: inherit; font-size: 12px; font-weight: 600; padding: 8px 10px;',
    scoreCard: 'background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; display: grid; gap: 6px; padding: 16px;',
    score: 'font-size: 30px; font-weight: 700; letter-spacing: -0.05em; line-height: 1;',
    recommendation: 'color: #334155; font-size: 13px; line-height: 1.45; margin: 0;',
    footer: 'align-items: center; border-top: 1px solid #e2e8f0; display: flex; gap: 12px; justify-content: space-between; padding: 16px 24px 24px;',
    muted: 'color: #64748b; font-size: 12px; line-height: 1.4;',
    error: 'color: #dc2626; font-size: 12px; line-height: 1.4; min-height: 18px;',
    button: 'background: #0f172a; border: 0; border-radius: 10px; color: #ffffff; cursor: pointer; font: inherit; font-size: 14px; font-weight: 600; padding: 10px 16px;'
  };

  const applyStyle = (element, style) => {
    element.style.cssText = style;
    return element;
  };

  const page = applyStyle(document.createElement('main'), styles.page);
  const card = applyStyle(document.createElement('section'), styles.card);
  const header = applyStyle(document.createElement('header'), styles.header);

  const badge = applyStyle(document.createElement('span'), styles.badge);
  badge.textContent = 'Risk assessment';

  const title = document.createElement('h2');
  title.textContent = 'Score this risk';
  applyStyle(title, styles.title);

  const hint = document.createElement('p');
  hint.textContent = 'Select the likelihood and impact. The matrix computes risk score, band, and recommended workflow action.';
  applyStyle(hint, styles.description);

  const body = applyStyle(document.createElement('div'), styles.body);
  const scoreCard = applyStyle(document.createElement('div'), styles.scoreCard);
  const scoreValue = applyStyle(document.createElement('strong'), styles.score);
  const recommendation = applyStyle(document.createElement('p'), styles.recommendation);
  const matrix = applyStyle(document.createElement('div'), styles.matrix);
  const cells = [];

  function riskScore() {
    return state.likelihood * state.impact;
  }

  function riskBand(score) {
    if (score >= 20) return 'critical';
    if (score >= 12) return 'high';
    if (score >= 6) return 'medium';
    return 'low';
  }

  function riskColor(score) {
    const band = riskBand(score);
    if (band === 'critical') return { bg: '#fee2e2', border: '#fecaca', text: '#991b1b' };
    if (band === 'high') return { bg: '#ffedd5', border: '#fed7aa', text: '#9a3412' };
    if (band === 'medium') return { bg: '#fef9c3', border: '#fde68a', text: '#854d0e' };
    return { bg: '#dcfce7', border: '#bbf7d0', text: '#166534' };
  }

  function recommendedAction(score) {
    const band = riskBand(score);
    if (band === 'critical') return 'Escalate immediately and require an owner-approved mitigation plan.';
    if (band === 'high') return 'Assign an owner and schedule mitigation before the workflow proceeds.';
    if (band === 'medium') return 'Track the risk and define a follow-up checkpoint.';
    return 'Accept or monitor the risk with no immediate escalation.';
  }

  function suggestedOwner(score) {
    const band = riskBand(score);
    if (band === 'critical') return 'Executive sponsor';
    if (band === 'high') return 'Risk owner';
    if (band === 'medium') return 'Project lead';
    return 'Process owner';
  }

  function mitigationTemplate(score) {
    const band = riskBand(score);
    if (band === 'critical') {
      return [
        'Confirm executive owner and decision deadline.',
        'Define containment steps and immediate customer/workflow impact.',
        'Schedule daily review until the risk is reduced.'
      ];
    }
    if (band === 'high') {
      return [
        'Assign a named risk owner.',
        'Agree mitigation actions before this workflow proceeds.',
        'Set a follow-up checkpoint and due date.'
      ];
    }
    if (band === 'medium') {
      return [
        'Track this risk in the project plan.',
        'Review status at the next checkpoint.'
      ];
    }
    return ['Monitor this risk unless likelihood or impact changes.'];
  }

  function escalationTemplate(score) {
    const band = riskBand(score);
    if (band === 'critical') return 'Critical risk requires immediate escalation and mitigation approval.';
    if (band === 'high') return 'High risk requires owner acknowledgement before proceeding.';
    return '';
  }

  function renderMitigationActions() {
    actionsList.replaceChildren();
    state.mitigationActions.forEach((action, index) => {
      const row = applyStyle(document.createElement('div'), styles.actionRow);
      const input = document.createElement('input');
      input.value = action;
      input.placeholder = 'Mitigation action';
      applyStyle(input, styles.control);
      input.addEventListener('input', () => {
        state.mitigationActions[index] = input.value;
      });

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      applyStyle(remove, styles.removeButton);
      remove.addEventListener('click', () => {
        state.mitigationActions.splice(index, 1);
        renderMitigationActions();
        runtime.resize();
      });

      row.append(input, remove);
      actionsList.append(row);
    });
  }

  function updateMatrix() {
    const score = riskScore();
    const band = riskBand(score);
    scoreValue.textContent = band.toUpperCase() + ' · ' + score + ' / 25';
    recommendation.textContent = recommendedAction(score);
    state.owner = suggestedOwner(score);
    state.escalationReason = escalationTemplate(score);
    state.mitigationActions = mitigationTemplate(score);
    owner.value = state.owner;
    escalation.value = state.escalationReason;
    escalationLabel.style.display = band === 'critical' || band === 'high' ? 'grid' : 'none';
    renderMitigationActions();
    cells.forEach(({ button, likelihood, impact, score }) => {
      const selected = likelihood === state.likelihood && impact === state.impact;
      const color = riskColor(score);
      button.style.cssText =
        styles.cell +
        'background: ' +
        color.bg +
        '; border-color: ' +
        color.border +
        '; color: ' +
        color.text +
        ';' +
        (selected ? styles.cellSelected : '');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    runtime.resize();
  }

  matrix.append(applyStyle(document.createElement('div'), styles.matrixHeader));
  impactColumns.forEach(column => {
    const headerCell = applyStyle(document.createElement('div'), styles.matrixHeader);
    headerCell.textContent = column.label;
    matrix.append(headerCell);
  });
  likelihoodRows.forEach(row => {
    const rowHeader = applyStyle(document.createElement('div'), styles.rowHeader);
    rowHeader.textContent = row.label;
    matrix.append(rowHeader);
    impactColumns.forEach(column => {
      const score = row.value * column.value;
      const band = riskBand(score);
      const button = applyStyle(document.createElement('button'), styles.cell);
      const label = applyStyle(document.createElement('span'), styles.cellTitle);
      const detail = applyStyle(document.createElement('span'), styles.cellDetail);
      button.type = 'button';
      label.textContent = score + ' / 25';
      detail.textContent = band;
      button.append(label, detail);
      button.addEventListener('click', () => {
        state.likelihood = row.value;
        state.impact = column.value;
        updateMatrix();
      });
      cells.push({ button, likelihood: row.value, impact: column.value, score });
      matrix.append(button);
    });
  });

  const ownerLabel = applyStyle(document.createElement('label'), styles.label);
  ownerLabel.append('Suggested owner');
  const owner = document.createElement('input');
  owner.placeholder = 'Who should own the mitigation?';
  applyStyle(owner, styles.control);
  owner.addEventListener('input', () => {
    state.owner = owner.value.trim();
  });
  ownerLabel.append(owner);

  const escalationLabel = applyStyle(document.createElement('label'), styles.label);
  escalationLabel.append('Escalation reason');
  const escalation = document.createElement('textarea');
  escalation.rows = 3;
  escalation.placeholder = 'Required for high and critical risks.';
  applyStyle(escalation, styles.textarea);
  escalation.addEventListener('input', () => {
    state.escalationReason = escalation.value;
  });
  escalationLabel.append(escalation);

  const actionsLabel = applyStyle(document.createElement('label'), styles.label);
  actionsLabel.append('Mitigation actions');
  const actionsList = applyStyle(document.createElement('div'), styles.actions);
  const addAction = document.createElement('button');
  addAction.type = 'button';
  addAction.textContent = 'Add mitigation action';
  applyStyle(addAction, styles.secondaryButton);
  addAction.addEventListener('click', () => {
    state.mitigationActions.push('');
    renderMitigationActions();
    runtime.resize();
  });
  actionsLabel.append(actionsList, addAction);

  const footer = applyStyle(document.createElement('footer'), styles.footer);
  const helper = applyStyle(document.createElement('small'), styles.muted);
  helper.textContent = 'The selected risk cell and recommended action will be returned to the workflow.';
  const error = applyStyle(document.createElement('div'), styles.error);

  const submit = document.createElement('button');
  submit.type = 'button';
  submit.textContent = 'Submit risk';
  applyStyle(submit, styles.button);
  submit.addEventListener('click', () => {
    if (!state.owner) {
      error.textContent = 'Add an owner before submitting.';
      owner.focus();
      return;
    }
    const score = riskScore();
    runtime.submit('submitted', {
      likelihood: state.likelihood,
      impact: state.impact,
      risk_score: score,
      risk_band: riskBand(score),
      recommended_action: recommendedAction(score),
      escalation_required: riskBand(score) === 'critical' || riskBand(score) === 'high',
      escalation_reason: state.escalationReason,
      owner: state.owner,
      mitigation_actions: state.mitigationActions.filter(action => action.trim())
    });
  });

  scoreCard.append(scoreValue, recommendation);
  header.append(badge, title, hint);
  body.append(scoreCard, matrix, ownerLabel, escalationLabel, actionsLabel, error);
  footer.append(helper, submit);
  card.append(header, body, footer);
  page.append(card);
  updateMatrix();
  root.replaceChildren(page);
});`;

export const ARTIFACT_TYPES = {
  HTML_FORM: 'html_form',
  TYPESCRIPT_APP: 'typescript_app',
};

export const ARTIFACT_SOURCE_LANGUAGES = {
  HTML: 'html',
  TYPESCRIPT: 'typescript',
};

export const DEFAULT_ARTIFACT_TYPE = ARTIFACT_TYPES.HTML_FORM;

export const ARTIFACT_SOURCE_LANGUAGE_PRESENTATION = {
  [ARTIFACT_SOURCE_LANGUAGES.HTML]: {
    label: 'HTML',
    editorLanguage: 'html',
  },
  [ARTIFACT_SOURCE_LANGUAGES.TYPESCRIPT]: {
    label: 'TypeScript',
    editorLanguage: 'typescript',
  },
};

export const ARTIFACT_TYPE_PRESENTATION = {
  [ARTIFACT_TYPES.HTML_FORM]: {
    label: 'HTML form',
    renderer: 'safe_html',
    defaultSourceLanguage: ARTIFACT_SOURCE_LANGUAGES.HTML,
    sourceLanguages: [ARTIFACT_SOURCE_LANGUAGES.HTML],
    defaultSource: DEFAULT_ARTIFACT_HTML,
  },
  [ARTIFACT_TYPES.TYPESCRIPT_APP]: {
    label: 'TypeScript app',
    renderer: 'sandboxed_js_app',
    defaultSourceLanguage: ARTIFACT_SOURCE_LANGUAGES.TYPESCRIPT,
    sourceLanguages: [ARTIFACT_SOURCE_LANGUAGES.TYPESCRIPT],
    defaultSource: DEFAULT_ARTIFACT_TYPESCRIPT,
  },
};

export function getArtifactTypePresentation(
  artifactType = DEFAULT_ARTIFACT_TYPE
) {
  return (
    ARTIFACT_TYPE_PRESENTATION[artifactType] || {
      label: artifactType || 'Artifact',
      renderer: 'safe_html',
      defaultSourceLanguage: ARTIFACT_SOURCE_LANGUAGES.HTML,
      sourceLanguages: [ARTIFACT_SOURCE_LANGUAGES.HTML],
      defaultSource: '',
    }
  );
}

export function getArtifactTypeOptions() {
  return Object.entries(ARTIFACT_TYPE_PRESENTATION).map(([value, presentation]) => ({
    value,
    label: presentation.label,
  }));
}

export function getArtifactSourceLanguagePresentation(sourceLanguage) {
  return (
    ARTIFACT_SOURCE_LANGUAGE_PRESENTATION[sourceLanguage] || {
      label: sourceLanguage || 'Plain text',
      editorLanguage: 'text',
    }
  );
}

export function getArtifactSourceLanguageOptions(
  artifactType = DEFAULT_ARTIFACT_TYPE
) {
  const typePresentation = getArtifactTypePresentation(artifactType);
  return typePresentation.sourceLanguages.map(sourceLanguage => {
    const languagePresentation =
      getArtifactSourceLanguagePresentation(sourceLanguage);
    return {
      value: sourceLanguage,
      label: languagePresentation.label,
    };
  });
}

export const DEFAULT_ARTIFACT_ALLOWED_EVENTS = [
  {
    name: 'submitted',
    description: 'Submit the completed artifact response.',
    closesArtifact: true,
    branchLabel: 'Submitted',
    payloadSchema: {
      type: 'object',
      additionalProperties: false,
      required: ['decision', 'owner', 'notes'],
      properties: {
        decision: {
          type: 'string',
          enum: ['approved', 'needs_changes', 'blocked'],
        },
        owner: {
          type: 'string',
          minLength: 1,
          maxLength: 160,
        },
        due_date: {
          type: 'string',
          maxLength: 64,
        },
        notes: {
          type: 'string',
          minLength: 1,
          maxLength: 4000,
        },
      },
    },
  },
];

export const DEFAULT_ARTIFACT_TYPESCRIPT_ALLOWED_EVENTS = [
  {
    name: 'submitted',
    description: 'Submit the computed risk assessment.',
    closesArtifact: true,
    branchLabel: 'Risk submitted',
    payloadSchema: {
      type: 'object',
      additionalProperties: false,
      required: [
        'likelihood',
        'impact',
        'risk_score',
        'risk_band',
        'recommended_action',
        'owner',
        'mitigation_actions',
      ],
      properties: {
        likelihood: {
          type: 'number',
          minimum: 1,
          maximum: 5,
        },
        impact: {
          type: 'number',
          minimum: 1,
          maximum: 5,
        },
        risk_score: {
          type: 'number',
          minimum: 1,
          maximum: 25,
        },
        risk_band: {
          type: 'string',
          enum: ['low', 'medium', 'high', 'critical'],
        },
        recommended_action: {
          type: 'string',
          minLength: 1,
          maxLength: 1000,
        },
        escalation_required: {
          type: 'boolean',
        },
        escalation_reason: {
          type: 'string',
          maxLength: 1000,
        },
        owner: {
          type: 'string',
          minLength: 1,
          maxLength: 160,
        },
        mitigation_actions: {
          type: 'array',
          items: {
            type: 'string',
            minLength: 1,
            maxLength: 500,
          },
        },
      },
    },
  },
];

export function getDefaultArtifactAllowedEvents(
  artifactType = DEFAULT_ARTIFACT_TYPE
) {
  return artifactType === ARTIFACT_TYPES.TYPESCRIPT_APP
    ? DEFAULT_ARTIFACT_TYPESCRIPT_ALLOWED_EVENTS
    : DEFAULT_ARTIFACT_ALLOWED_EVENTS;
}
